

<template>
  <!-- Cart Page Start -->
  <section class="cart_page_area">
    <div class="container">
      <div class="row">
        <div class="col-lg-8">
          <div class="cart-table-left">
            <h3>Shopping Cart</h3>
            <div class="table-responsive cart_box">
              <table class="table">
                <thead>
                <tr>
                  <th>Preview</th>
                  <th>Product</th>
                  <th>Price</th>
                  <th>Quantity</th>
                  <th>Total</th>
                  <th>Action</th>
                </tr>
                </thead>
                <tbody>
                <tr class="shop-cart-item" v-for="(product, key) in cartItems" :key="key">
                  <td class=" cart-preview">
                    <a href="#">
                      <img :src="require(`@/assets/img/${product.img}`)" alt="cart-1">
                    </a>
                  </td>
                  <td class=" cart-product">
                    <a href="#">
                      <p>{{ product.title }}</p>
                    </a>
                  </td>
                  <td class=" cart-price">
                    <p>£{{ product.price }}</p>
                  </td>
                  <td class=" cart-quantity">
                    <div class="num-block skin-2">
                      <div class="num-in">
                        <span class="minus dis" @click.prevent.stop="decrement(product)"></span>
                        <input type="text" class="in-num" v-bind:value="product.quantity" readonly="">
                        <span class="plus" @click.prevent.stop="increment(product)"></span>
                      </div>
                    </div>
                  </td>
                  <td class=" cart-total">
                    <p>£{{ product.total = (Number(product.price) * Number(product.quantity)).toFixed(2) }}</p>
                  </td>
                  <td class=" cart-close">
                    <a href="#" @click.stop.prevent="removeItem(product)"><i class="fa fa-times"></i></a>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="cart-clear">
              <a href="#">clear cart</a>
              <a href="#">update cart</a>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="order-summury-box">
            <h3>Order Summury</h3>
            <div class="summury-inn">
              <table>
                <tbody>
                <tr>
                  <td>Cart Subtotal</td>
                  <td>£{{ cartTotal }}</td>
                </tr>
                <tr>
                  <td>Shipping and Handling</td>
                  <td>Free Shipping</td>
                </tr>
                <tr>
                  <td>Order Total</td>
                  <td>£{{ cartTotal }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="checkout-action">
            <router-link to="/shop/checkout" class="cta_btn">Proceed to checkout <span></span></router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Cart Page End -->
</template>
<script>
import {mapState} from 'vuex';

export default {
  name: 'CartPageArea',
  computed: {
    ...mapState({
      carts: function (state) {
        return state.carts.items;
      }
    }),
    cartItems: {
      get: function () {
        return this.carts;
      },
      set: function (newValue) {
        // console.log('carts: ', newValue);
      }
    },
    cartTotal: {
      get: function () {
        return Number(
          this.cartItems
            .reduce(function (subTotal, item) {
              return Number.parseFloat(
                subTotal + Number(item.total)
              );
            }, 0)
            .toFixed(2)
        );
      },
      set: function (newValue) {
        // console.log('carts: ', newValue);
      }
    }
  },
  methods: {
    decrement(product) {
      //Decrement cart items
      let indexOf = this.cartItems.findIndex((item) => item.sku === product.sku);
      let prevQty = Number(this.cartItems[indexOf].quantity);

      this.cartItems[indexOf].quantity = prevQty--;
      this.cartItems = [...this.cartItems];
    },
    increment(product) {
      //Increment cart items
      let indexOf = this.cartItems.findIndex((item) => item.sku === product.sku);
      let prevQty = Number(this.cartItems[indexOf].quantity);

      this.cartItems[indexOf].quantity = ++prevQty;
      this.cartItems = [...this.cartItems];
    },
    removeItem(product) {
      //Remove cart item
      this.$store.dispatch('removeItem', product);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/products/CartPageArea.vue